import { Component, Inject, OnInit } from "@angular/core";
import { NavController, AlertController } from "ionic-angular";
import { LoginPage } from "../login.page/login.page";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import * as UserActions from "../../app/store/actions/user.actions";
import { TranslateService } from "@ngx-translate/core";
import {
  EnvironmentVariables,
  ENV_VARS,
  envTypes
} from "../../app/environment-variables/environment-variables.module";
import { NavParams } from "ionic-angular/navigation/nav-params";
import { LoadingController } from "ionic-angular/components/loading/loading-controller";
import { AdminService } from "../../app/services/admin.service";
import { IAdLoginPayload } from "../../app/models/types";
import { first, switchMap } from "rxjs/operators";
import { PatientPage } from "../patient.page/patient.page";
import { QuestionnaireResponseService } from "@zitelab/ionic-fhir-questionnaires";
import { DashboardService } from "../../app/services/dashboard.service";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import { AuthService } from "../../app/services/auth.service";
import { HomePage } from "../home.page/home.page";
import { WINDOW } from "../../app/services/window.service";

@Component({
  selector: "ad-login-page",
  templateUrl: "ad-login.page.html"
})
export class AdLoginPage implements OnInit {
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public store: Store<AppState>,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public questionnaireResponseService: QuestionnaireResponseService,
    public dashboard: DashboardService,
    @Inject(ENV_VARS) public envVars: EnvironmentVariables,
    @Inject(WINDOW) public window: Window
  ) {}

  ngOnInit() {
    console.log(this.navParams);
    const loading = this.loadingCtrl.create({
      content: "Logger ind",
      dismissOnPageChange: true
    });
    loading.present();
    const rawPayload = this.navParams.get("payload");
    const cleanedPayload = this.cleanPayload(rawPayload);
    this.window.history.pushState(
      {},
      null,
      `${this.window.location.protocol}//${this.window.location.host}`
    );
    this.store
      .select(state => state.hydrated)
      .pipe(first(hydrated => hydrated === true))
      // We await hydration of state so we don't our state overwritten
      .subscribe(result => {
        if (!cleanedPayload.hasOwnProperty("token")) {
          const errorAlert = this.alertCtrl.create({
            title: "Fejl ved login",
            message: cleanedPayload.error
          });
        } else {
          this.store.dispatch(
            new UserActions.SetJWTAction({
              jwt: cleanedPayload.token,
              userType: "Practitioner"
            })
          );
          this.store
            .select(state => state.user)
            .pipe(first(user => user.userFhir !== null))
            .subscribe(user => this.navCtrl.setRoot(HomePage));
        }
      });
  }

  cleanPayload(base64String: string): IAdLoginPayload {
    const string = JSON.parse(atob(base64String)) as IAdLoginPayload;
    return string;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ad-login.page/ad-login.page.ts